module.exports = __webpack_public_path__ + "img/20_pourcent.fcbf8dcf.png";